import { makeRequest } from '~shared/api/make-request';
import { config } from '~shared/config';

import { ResponseSuccess } from '@breezeventures/scp-client';

export const getChatToken = async (): Promise<string> => {
  const response = await makeRequest<ResponseSuccess<{ chatToken: string }>>({
    url: `${config.apiHost}/auth/api/v1/merchant_authorizer/tokens/chat/generate`,
    credentials: 'include',
  });
  return response.payload.chatToken;
};
